import React, { useState } from "react";
import styled from "styled-components";
import AccordionWrapper from "./inspection/AccordionWrapper";
import FlasherData from "./FlasherData";
import { ModuleData, ProductData } from "../handlers";
import { isFlasherValid } from "../helpers";

// Badge customizado para o status do Flasher
const StatusBadge = styled.span<{ isValid: boolean }>`
  background-color: ${(props) => (props.isValid ? "#4caf50" : "#ffc107")};
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-weight: bold;
  font-size: 1rem;
`;

interface FlasherAccordionProps {
  moduleData: ModuleData;
  productData: ProductData;
  initialIsOpen?: boolean;
  isModuleValid: (isValid: boolean) => void;
}

const FlasherAccordion: React.FC<FlasherAccordionProps> = ({
  moduleData,
  productData,
  initialIsOpen = false,
  isModuleValid,
}) => {
  const [isOpen, setIsOpen] = useState(initialIsOpen);
  const isValid = isFlasherValid(moduleData, productData, isModuleValid);
  const statusText = isValid ? "Valid" : "Check";

  // Criamos o elemento do badge para passar como prop
  const flasherHeaderBadge = (
    <StatusBadge isValid={isValid}>{statusText}</StatusBadge>
  );

  return (
    <AccordionWrapper
      header="Flasher Inspection"
      headerBadge={flasherHeaderBadge}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    >
      <FlasherData
        moduleData={moduleData}
        productData={productData}
        isModuleValid={isModuleValid}
      />
    </AccordionWrapper>
  );
};

export default FlasherAccordion;
